import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-white border-t border-slate-200 mt-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <Logo height={60} />
                        <p className="mt-5 text-slate-600 leading-relaxed max-w-md">
                            Et samlet flow til kundehenvendelser, opgaver, medarbejdere, tid, materialer og dokumentation.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">Links</h4>
                        <ul className="space-y-2.5 text-sm">
                            {[
                                { to: "/fordele", label: "Fordele" },
                                { to: "/funktioner", label: "Funktioner" },
                                { to: "/brancher", label: "Brancher" },
                                { to: "/priser", label: "Priser" },
                                { to: "/kontakt", label: "Kontakt" },
                            ].map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-link-${l.to.replace("/", "")}`}
                                        className="text-slate-600 hover:text-blue-600 transition-colors"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">Kontakt</h4>
                        <ul className="space-y-3 text-sm">
                            <li className="flex items-start gap-3">
                                <Phone className="w-4 h-4 text-blue-600 mt-0.5" />
                                <a href="tel:60566805" className="text-slate-700 hover:text-blue-600">60 56 68 05</a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail className="w-4 h-4 text-blue-600 mt-0.5" />
                                <a href="mailto:Xenius@Gregersen.dk" className="text-slate-700 hover:text-blue-600 break-all">
                                    Xenius@Gregersen.dk
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin className="w-4 h-4 text-blue-600 mt-0.5" />
                                <span className="text-slate-700">Vibevænget 3, 5700 Svendborg</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-slate-500">
                        © {new Date().getFullYear()} MyServiceHelper. Alle rettigheder forbeholdes.
                    </p>
                    <p className="text-xs text-slate-400">Bygget i Danmark</p>
                </div>
            </div>
        </footer>
    );
}
